(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-season"] && !Shopify.designMode) return;
  try {
    
  class InstantPagesLoad extends HTMLElement {
    constructor() {
      super();

      // Cache DOM elements
      this.collectionsGrid = document.querySelector('#collection-grid');
      this.loading = this.querySelector('.loading-overlay');
      this.seo = document.querySelector('#section__collection-seo');

      // Initialize state
      this.seasonInUrl = this.extractSeasonFromUrl();

      // Remove the default link
      const defaultLink = this.querySelector('a');
      if (defaultLink) defaultLink.remove();

      if (!this.collectionsGrid) return;

      if (this.seo) {
        this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
      }

      this.loadAllPages(this.dataset.url);
    }

    extractSeasonFromUrl() {
      const url = window.location.href.toLowerCase();
      const hash = window.location.hash.replace('#', '');
      const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];

      // Check hash first, then URL path
      if (hash && seasons.includes(hash)) {
        return hash;
      }

      return seasons.find((season) => url.includes(season)) || '';
    }

    async loadAllPages(url) {
      if (!url) return;

      this.loading.classList.remove('dn');

      try {
        while (url) {
          const response = await fetch(url);
          const text = await response.text();
          const html = document.createElement('div');
          html.innerHTML = text;

          const collections = html.querySelector('#collection-grid');
          const nextPage = html.querySelector('instant-pages-load');

          if (collections) {
            this.appendNewCollections(collections);
          }

          url = nextPage ? nextPage.dataset.url : null;
        }
      } catch (error) {
        console.error('Error loading pages:', error);
      } finally {
        this.loading.classList.add('dn');
        if (this.seo) {
          this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
        }
        InstantPagesLoad.sortCollectionsGrid();
        if (this.collectionsGrid) {
          this.collectionsGrid.dataset.sortPending = 'false';
        }
        // Only initialize filtering once globally
        InstantPagesLoad.initializeGlobalFiltering();
      }
    }

    appendNewCollections(collections) {
      collections.querySelectorAll('.collection__item').forEach((newItem) => {
        const existingItem = this.collectionsGrid.querySelector(`[data-id="${newItem.dataset.id}"]`);
        if (!existingItem) {
          this.collectionsGrid.appendChild(newItem.cloneNode(true));
        }
      });
    }

    static sortCollectionsGrid() {
      const grid = document.querySelector('#collection-grid');
      if (!grid) return;

      const sortBy = grid.dataset.sortBy || 'published_at';
      const sortDirection = grid.dataset.sortDirection || 'asc';
      const multiplier = sortDirection === 'desc' ? -1 : 1;

      const items = Array.from(grid.querySelectorAll('.collection__item'));
      if (items.length < 2) return;

      items.sort((a, b) => {
        if (sortBy === 'published_at') {
          const aVal = parseInt(a.dataset.sortPublishedAt || '0', 10);
          const bVal = parseInt(b.dataset.sortPublishedAt || '0', 10);
          if (aVal !== bVal) return (aVal - bVal) * multiplier;
        } else if (sortBy === 'products_count') {
          const aVal = parseInt(a.dataset.sortProductsCount || '0', 10);
          const bVal = parseInt(b.dataset.sortProductsCount || '0', 10);
          if (aVal !== bVal) return (aVal - bVal) * multiplier;
        } else {
          const aVal = a.dataset.sortTitle || '';
          const bVal = b.dataset.sortTitle || '';
          const titleCmp = aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
          if (titleCmp !== 0) return titleCmp * multiplier;
        }

        // Stable tie-breaker: title ascending
        const aTitle = a.dataset.sortTitle || '';
        const bTitle = b.dataset.sortTitle || '';
        return aTitle.localeCompare(bTitle, undefined, { sensitivity: 'base' });
      });

      const frag = document.createDocumentFragment();
      items.forEach((item) => frag.appendChild(item));
      grid.appendChild(frag);
    }

    // Static method to ensure filtering is only initialized once
    static initializeGlobalFiltering() {
      // Use a static flag to ensure this only runs once
      if (InstantPagesLoad.filteringInitialized) return;

      InstantPagesLoad.filteringInitialized = true;

      const seasonInUrl = InstantPagesLoad.extractSeasonFromUrl();
      console.log('Initializing season filtering for:', seasonInUrl);

      InstantPagesLoad.addSeasonFilterListeners();
      InstantPagesLoad.preSelectSeason(seasonInUrl);
    }

    static extractSeasonFromUrl() {
      const url = window.location.href.toLowerCase();
      const hash = window.location.hash.replace('#', '');
      const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];

      // Check hash first, then URL path
      if (hash && seasons.includes(hash)) {
        return hash;
      }

      return seasons.find((season) => url.includes(season)) || '';
    }

    static addSeasonFilterListeners() {
      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab a');

      seasonFilterTabs.forEach((filter) => {
        filter.addEventListener('click', (e) => InstantPagesLoad.handleSeasonClick(e, filter));
      });
    }

    static handleSeasonClick(e, filter) {
      e.preventDefault();

      // Prevent rapid clicking
      if (filter.dataset.processing) return;
      filter.dataset.processing = 'true';

      setTimeout(() => {
        delete filter.dataset.processing;
      }, 300);

      // Don't process if already active
      if (filter.parentElement.classList.contains('active')) {
        return;
      }

      InstantPagesLoad.updateActiveTab(filter);
      InstantPagesLoad.applySeasonFilter(filter.getAttribute('data-season'));
      InstantPagesLoad.updateUrlHash(filter.getAttribute('data-season'));
    }

    static updateActiveTab(activeFilter) {
      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab');

      seasonFilterTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      activeFilter.parentElement.classList.add('active');
    }

    static applySeasonFilter(selectedSeason) {
      const collections = document.querySelectorAll('.collection__item');

      collections.forEach((collection) => {
        const itemSeasons = collection.getAttribute('data-item-season');
        if (!itemSeasons) return;

        const seasonList = itemSeasons.toLowerCase().split(' - ');
        const shouldShow = selectedSeason === 'all' || seasonList.includes(selectedSeason);

        if (shouldShow) {
          collection.classList.remove('dn');
          collection.classList.add('db');
        } else {
          collection.classList.remove('db');
          collection.classList.add('dn');
        }
      });

      // Trigger a custom event for other components that might need to know
      document.dispatchEvent(
        new CustomEvent('seasonFilterChanged', {
          detail: { season: selectedSeason },
        })
      );
    }

    static updateUrlHash(season) {
      if (season === 'all') {
        // Remove hash for 'all'
        if (window.location.hash) {
          history.replaceState(null, null, window.location.pathname + window.location.search);
        }
      } else {
        // Update hash for specific season
        history.replaceState(null, null, `${window.location.pathname}${window.location.search}#${season}`);
      }
    }

    static preSelectSeason(seasonInUrl) {
      if (!seasonInUrl) return;

      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab a');
      const targetFilter = Array.from(seasonFilterTabs).find(
        (filter) => filter.getAttribute('data-season') === seasonInUrl
      );

      if (targetFilter) {
        // Use a small delay to ensure DOM is ready
        setTimeout(() => {
          targetFilter.click();
        }, 100);
      }
    }
  }
  customElements.define('instant-pages-load', InstantPagesLoad);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stock-photos-fullwidth"]) return;
  try {
    
    class InfiniteScroll extends HTMLElement {
      constructor() {
        super();

        this.productsGrid = document.querySelector('#product-grid');
        this.loading = this.querySelector('.loading-overlay');
        this.seo = document.querySelector('#section__collection-seo');
        this.storageKey = `collection-scroll-${window.location.pathname}`;
        this.currentPage = 1;
        this.isRestoring = false; // Flag to prevent interference during restoration
        this.restorationCompleted = false; // Flag to prevent multiple restoration attempts
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) {
            console.log('Page restored from bfcache');
            sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          } else {
            console.log('Normal load');
          }
        });

        this.querySelector('a').remove();

        if (!this.productsGrid) return;

        if (this.seo) this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');

        // Only set up scroll tracking once
        InfiniteScroll.setupGlobalScrollTracking(this.storageKey);

        // Check if we need to restore state - only once at page load
        this.checkAndRestoreScrollState();

        // Set up intersection observer for normal infinite scroll
        const handleIntersection = (entries, observer) => {
          // Don't trigger infinite scroll if we're in the middle of restoration
          if (this.isRestoring || this.restorationCompleted === false || !entries[0].isIntersecting) {
            return;
          }
          this.loadNextPage();
        };

        this.observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' });
        this.observer.observe(this);
      }

      // Static method to ensure scroll tracking is only set up once globally
      static setupGlobalScrollTracking(storageKey) {
        // Use a global window flag to ensure this only runs once per page
        if (window.infiniteScrollTrackingInitialized) {
          console.log('📋 Scroll tracking already initialized, skipping setup...');
          return;
        }

        console.log('🚀 Initializing scroll tracking for the first time...');
        window.infiniteScrollTrackingInitialized = true;

        // Create a consistent storage key for this collection page
        const globalStorageKey = `collection-scroll-${window.location.pathname}`;

        // Track when clicking on product links with line item numbers
        document.addEventListener('click', (e) => {
          if (e.target.closest('.quick-add-btn')) {
            return;
          }
          const productLink = e.target.closest('#product-grid li a[href*="/products/"]');
          if (productLink) {
            // Find the parent <li> element with data-item-number
            const listItem = productLink.closest('li[data-item-number]');

            if (listItem) {
              const itemNumber = parseInt(listItem.getAttribute('data-item-number'));
              const infiniteScrollElement = document.querySelector('infinite-scroll');

              if (infiniteScrollElement && infiniteScrollElement.dataset.url) {
                const infiniteScrollUrl = infiniteScrollElement.dataset.url;
                const queryString = infiniteScrollUrl.split('?')[1] || '';
                const urlParams = new URLSearchParams(queryString);
                console.log(infiniteScrollElement);
                let currentPage;
                if (infiniteScrollElement.dataset.lastPage) {
                  currentPage = parseInt(urlParams.get('page') || '1');
                } else {
                  const page = parseInt(urlParams.get('page') || '1');
                  currentPage = page - 1;
                } // Save state for any item clicked (not just page > 1)
                const productTitle = productLink.querySelector('.product-info .lh-title, h3, .product-title');
                const productTitleText = productTitle ? productTitle.textContent.trim() : '';

                console.log(
                  'Saving state on product click - Item:',
                  itemNumber,
                  'Page:',
                  currentPage,
                  'Scroll:',
                  window.pageYOffset
                );

                // Use the consistent global storage key
                sessionStorage.setItem(
                  `Last Page Position URL: ${globalStorageKey}`,
                  JSON.stringify({
                    clickedItemNumber: itemNumber,
                    collectionRelatedPathname: window.location.pathname,
                    atProduct: productTitleText,
                    productLink: productLink.href,
                    infiniteScrollPage: currentPage,
                    scrollPosition: window.pageYOffset,
                    timestamp: Date.now(),
                  })
                );
              }
            }
          }
        });
      }

      // This only runs once when the page loads
      checkAndRestoreScrollState() {
        const savedState = sessionStorage.getItem(`Last Page Position URL: ${this.storageKey}`);

        // Use a global flag to prevent multiple restoration attempts across instances
        if (window.infiniteScrollRestorationStarted) {
          console.log('🚫 Restoration already started by another instance, skipping...');
          this.restorationCompleted = true;
          return;
        }

        // Prevent multiple restoration attempts
        if (this.restorationCompleted !== false) {
          console.log('🚫 Restoration already completed or in progress, skipping...');
          return;
        }

        if (!savedState) {
          console.log('📭 No saved state found, marking restoration as completed');
          this.restorationCompleted = true;
          return;
        }

        try {
          const state = JSON.parse(savedState);
          const { infiniteScrollPage, scrollPosition, clickedItemNumber, timestamp } = state;

          // Check if the saved state is recent (within 5 minutes)
          const fiveMinutesInMs = 5 * 60 * 1000;
          const isRecent = Date.now() - timestamp < fiveMinutesInMs;

          if (!isRecent) {
            // Clean up old state
            sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
            console.log('🗑️ Removed expired state, marking restoration as completed');
            this.restorationCompleted = true;
            return;
          }

          console.log(
            `🎯 Starting restoration: Item ${clickedItemNumber}, Page ${infiniteScrollPage}, Position ${scrollPosition}`
          );

          // Mark that restoration has started globally
          window.infiniteScrollRestorationStarted = true;

          // Start the restoration process
          this.isRestoring = true;
          this.loadPagesToTarget(infiniteScrollPage, clickedItemNumber, scrollPosition);
        } catch (error) {
          console.error('Error parsing saved scroll state:', error);
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          this.restorationCompleted = true;
        }
      }

      async loadPagesToTarget(targetPage, targetItemNumber, fallbackScrollPosition) {
        // Show loading indicator
        this.loading.classList.remove('dn');

        try {
          // Only proceed if we have pages to load
          if (targetPage && targetPage > 1) {
            console.log(`Need to load ${targetPage} pages before scrolling to item ${targetItemNumber}`);

            // Load pages sequentially from page 2 to target page
            for (let page = 2; page <= targetPage; page++) {
              console.log(`Loading page ${page} of ${targetPage}...`);

              // Check if we still have a URL to load
              if (!this.dataset.url) {
                console.log('No more pages to load');
                break;
              }

              // Load the next page
              const response = await fetch(this.dataset.url);
              const text = await response.text();
              const html = document.createElement('div');
              html.innerHTML = text;

              const products = html.querySelector('#product-grid');
              const infinite = html.querySelector('infinite-scroll');

              if (products && products.innerHTML.trim().length) {
                // Get the current number of items to continue numbering from
                const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
                const lastItemNumber =
                  existingItems.length > 0
                    ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                    : 0;

                // Update line item numbers for new items before adding to DOM
                const newItems = products.querySelectorAll('li[data-item-number]');
                newItems.forEach((item, index) => {
                  const newItemNumber = lastItemNumber + index + 1;
                  item.setAttribute('data-item-number', newItemNumber);
                });

                // Add the updated items to the grid
                this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
                this.currentPage = page;

                console.log(
                  `✅ Page ${page} loaded successfully. Grid now has ${
                    this.productsGrid.querySelectorAll('li[data-item-number]').length
                  } items`
                );
              }

              // Update the URL for the next page
              if (infinite) {
                this.dataset.url = infinite.dataset.url;
                this.dataset.currentPage = page;
              } else {
                // No more pages available
                this.dataset.lastPage = true;
                if (this.seo) {
                  this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
                }
                console.log('No more pages available');
                break;
              }

              // Small delay to prevent overwhelming the server
              await new Promise((resolve) => setTimeout(resolve, 100));
            }

            console.log(`🎯 All pages loaded! Now attempting to scroll to item ${targetItemNumber}`);
          } else {
            console.log('No additional pages needed, target item should already be available');
          }

          // Hide loading indicator
          this.loading.classList.add('dn');

          // NOW scroll to the target item (only after all pages are loaded)
          setTimeout(() => {
            console.log('🔍 Searching for target item in loaded content...');
            this.scrollToTargetItem(targetItemNumber, fallbackScrollPosition);

            // Clean up the saved state after successful restoration
            sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);

            // Mark restoration as complete and reset global flag
            this.isRestoring = false;
            this.restorationCompleted = true;
            window.infiniteScrollRestorationStarted = false; // Reset for potential future use
            console.log('✅ Restoration process completed and marked as done');
          }, 300); // Increased timeout to ensure DOM is fully updated
        } catch (error) {
          console.error('Error loading pages for scroll restoration:', error);
          this.loading.classList.add('dn');
          this.isRestoring = false;
          this.restorationCompleted = true;
          window.infiniteScrollRestorationStarted = false; // Reset on error too

          // Clean up on error
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        }
      }

      // Scroll to the specific line item that was clicked
      scrollToTargetItem(targetItemNumber, fallbackScrollPosition) {
        // Debug: Log current state
        const currentItems = this.productsGrid.querySelectorAll('li[data-item-number]');
        console.log(`📊 Current grid has ${currentItems.length} items numbered from 1 to ${currentItems.length}`);

        if (targetItemNumber) {
          console.log(`🎯 Looking for target item #${targetItemNumber}...`);

          // Find the target item by data-item-number
          const targetItem = this.productsGrid.querySelector(`li[data-item-number="${targetItemNumber}"]`);

          if (targetItem) {
            // Scroll to the target item with some offset
            const offsetTop = targetItem.offsetTop - 100; // 100px offset from top

            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth',
            });

            console.log(`✅ Successfully scrolled to item ${targetItemNumber} at position ${offsetTop}`);

            setTimeout(() => {
              targetItem.style.transform = '';
              targetItem.style.boxShadow = '';
              console.log('✨ Target item highlight removed');
            }, 1000);

            sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
            return;
          } else {
            console.log(`❌ Target item ${targetItemNumber} not found in ${currentItems.length} loaded items`);
            console.log(
              'Available item numbers:',
              Array.from(currentItems).map((item) => item.getAttribute('data-item-number'))
            );
          }
        }

        // Fallback to scroll position if item not found
        if (fallbackScrollPosition) {
          window.scrollTo({
            top: fallbackScrollPosition,
            behavior: 'smooth',
          });

          console.log(`📍 Used fallback scroll to position ${fallbackScrollPosition}`);
        } else {
          console.log('⚠️ No target item or fallback position available');
        }
      }

      loadNextPage() {
        this.loading.classList.remove('dn');
        this.currentPage++;

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const products = html.querySelector('#product-grid');
            const infinite = html.querySelector('infinite-scroll');

            if (products && products.innerHTML.trim().length) {
              // Get the current number of items to continue numbering from
              const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
              const lastItemNumber =
                existingItems.length > 0
                  ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                  : 0;

              // Update line item numbers for new items before adding to DOM
              const newItems = products.querySelectorAll('li[data-item-number]');
              newItems.forEach((item, index) => {
                const newItemNumber = lastItemNumber + index + 1;
                item.setAttribute('data-item-number', newItemNumber);
              });

              // Add the updated items to the grid
              this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
            }

            if (infinite) {
              this.dataset.url = infinite.dataset.url;
              this.dataset.currentPage = this.currentPage;
            } else {
              this.dataset.lastPage = true;
              this.observer.unobserve(this);
              if (this.seo) this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
            }
            this.loading.classList.add('dn');
          })
          .catch((e) => {
            this.loading.classList.add('dn');
            console.error(e);
          });
      }
    }
    customElements.define('infinite-scroll', InfiniteScroll);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stock-photos"]) return;
  try {
    
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();

      this.productsGrid = document.querySelector('#product-grid');
      this.loading = this.querySelector('.loading-overlay');
      this.seo = document.querySelector('#section__collection-seo');
      this.storageKey = `collection-scroll-${window.location.pathname}`;
      this.currentPage = 1;
      this.isRestoring = false; // Flag to prevent interference during restoration
      this.restorationCompleted = false; // Flag to prevent multiple restoration attempts
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          console.log('Page restored from bfcache');
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        } else {
          console.log('Normal load');
        }
      });

      this.querySelector('a').remove();

      if (!this.productsGrid) return;

      if (this.seo) this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');

      // Only set up scroll tracking once
      InfiniteScroll.setupGlobalScrollTracking(this.storageKey);

      // Check if we need to restore state - only once at page load
      this.checkAndRestoreScrollState();

      // Set up intersection observer for normal infinite scroll
      const handleIntersection = (entries, observer) => {
        // Don't trigger infinite scroll if we're in the middle of restoration
        if (this.isRestoring || this.restorationCompleted === false || !entries[0].isIntersecting) {
          return;
        }
        this.loadNextPage();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' });
      this.observer.observe(this);
    }

    // Static method to ensure scroll tracking is only set up once globally
    static setupGlobalScrollTracking(storageKey) {
      // Use a global window flag to ensure this only runs once per page
      if (window.infiniteScrollTrackingInitialized) {
        console.log('📋 Scroll tracking already initialized, skipping setup...');
        return;
      }

      console.log('🚀 Initializing scroll tracking for the first time...');
      window.infiniteScrollTrackingInitialized = true;

      // Create a consistent storage key for this collection page
      const globalStorageKey = `collection-scroll-${window.location.pathname}`;

      // Track when clicking on product links with line item numbers
      document.addEventListener('click', (e) => {
        if (e.target.closest('.quick-add-btn')) {
          return;
        }
        const productLink = e.target.closest('#product-grid li a[href*="/products/"]');
        if (productLink) {
          // Find the parent <li> element with data-item-number
          const listItem = productLink.closest('li[data-item-number]');

          if (listItem) {
            const itemNumber = parseInt(listItem.getAttribute('data-item-number'));
            const infiniteScrollElement = document.querySelector('infinite-scroll');

            if (infiniteScrollElement && infiniteScrollElement.dataset.url) {
              const infiniteScrollUrl = infiniteScrollElement.dataset.url;
              const queryString = infiniteScrollUrl.split('?')[1] || '';
              const urlParams = new URLSearchParams(queryString);
              console.log(infiniteScrollElement);
              let currentPage;
              if (infiniteScrollElement.dataset.lastPage) {
                currentPage = parseInt(urlParams.get('page') || '1');
              } else {
                const page = parseInt(urlParams.get('page') || '1');
                currentPage = page - 1;
              } // Save state for any item clicked (not just page > 1)
              const productTitle = productLink.querySelector('.product-info .lh-title, h3, .product-title');
              const productTitleText = productTitle ? productTitle.textContent.trim() : '';

              console.log(
                'Saving state on product click - Item:',
                itemNumber,
                'Page:',
                currentPage,
                'Scroll:',
                window.pageYOffset
              );

              // Use the consistent global storage key
              sessionStorage.setItem(
                `Last Page Position URL: ${globalStorageKey}`,
                JSON.stringify({
                  clickedItemNumber: itemNumber,
                  collectionRelatedPathname: window.location.pathname,
                  atProduct: productTitleText,
                  productLink: productLink.href,
                  infiniteScrollPage: currentPage,
                  scrollPosition: window.pageYOffset,
                  timestamp: Date.now(),
                })
              );
            }
          }
        }
      });
    }

    // This only runs once when the page loads
    checkAndRestoreScrollState() {
      const savedState = sessionStorage.getItem(`Last Page Position URL: ${this.storageKey}`);

      // Use a global flag to prevent multiple restoration attempts across instances
      if (window.infiniteScrollRestorationStarted) {
        console.log('🚫 Restoration already started by another instance, skipping...');
        this.restorationCompleted = true;
        return;
      }

      // Prevent multiple restoration attempts
      if (this.restorationCompleted !== false) {
        console.log('🚫 Restoration already completed or in progress, skipping...');
        return;
      }

      if (!savedState) {
        console.log('📭 No saved state found, marking restoration as completed');
        this.restorationCompleted = true;
        return;
      }

      try {
        const state = JSON.parse(savedState);
        const { infiniteScrollPage, scrollPosition, clickedItemNumber, timestamp } = state;

        // Check if the saved state is recent (within 5 minutes)
        const fiveMinutesInMs = 5 * 60 * 1000;
        const isRecent = Date.now() - timestamp < fiveMinutesInMs;

        if (!isRecent) {
          // Clean up old state
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          console.log('🗑️ Removed expired state, marking restoration as completed');
          this.restorationCompleted = true;
          return;
        }

        console.log(
          `🎯 Starting restoration: Item ${clickedItemNumber}, Page ${infiniteScrollPage}, Position ${scrollPosition}`
        );

        // Mark that restoration has started globally
        window.infiniteScrollRestorationStarted = true;

        // Start the restoration process
        this.isRestoring = true;
        this.loadPagesToTarget(infiniteScrollPage, clickedItemNumber, scrollPosition);
      } catch (error) {
        console.error('Error parsing saved scroll state:', error);
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        this.restorationCompleted = true;
      }
    }

    async loadPagesToTarget(targetPage, targetItemNumber, fallbackScrollPosition) {
      // Show loading indicator
      this.loading.classList.remove('dn');

      try {
        // Only proceed if we have pages to load
        if (targetPage && targetPage > 1) {
          console.log(`Need to load ${targetPage} pages before scrolling to item ${targetItemNumber}`);

          // Load pages sequentially from page 2 to target page
          for (let page = 2; page <= targetPage; page++) {
            console.log(`Loading page ${page} of ${targetPage}...`);

            // Check if we still have a URL to load
            if (!this.dataset.url) {
              console.log('No more pages to load');
              break;
            }

            // Load the next page
            const response = await fetch(this.dataset.url);
            const text = await response.text();
            const html = document.createElement('div');
            html.innerHTML = text;

            const products = html.querySelector('#product-grid');
            const infinite = html.querySelector('infinite-scroll');

            if (products && products.innerHTML.trim().length) {
              // Get the current number of items to continue numbering from
              const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
              const lastItemNumber =
                existingItems.length > 0
                  ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                  : 0;

              // Update line item numbers for new items before adding to DOM
              const newItems = products.querySelectorAll('li[data-item-number]');
              newItems.forEach((item, index) => {
                const newItemNumber = lastItemNumber + index + 1;
                item.setAttribute('data-item-number', newItemNumber);
              });

              // Add the updated items to the grid
              this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
              this.currentPage = page;

              console.log(
                `✅ Page ${page} loaded successfully. Grid now has ${
                  this.productsGrid.querySelectorAll('li[data-item-number]').length
                } items`
              );
            }

            // Update the URL for the next page
            if (infinite) {
              this.dataset.url = infinite.dataset.url;
              this.dataset.currentPage = page;
            } else {
              // No more pages available
              this.dataset.lastPage = true;
              if (this.seo) {
                this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
              }
              console.log('No more pages available');
              break;
            }

            // Small delay to prevent overwhelming the server
            await new Promise((resolve) => setTimeout(resolve, 100));
          }

          console.log(`🎯 All pages loaded! Now attempting to scroll to item ${targetItemNumber}`);
        } else {
          console.log('No additional pages needed, target item should already be available');
        }

        // Hide loading indicator
        this.loading.classList.add('dn');

        // NOW scroll to the target item (only after all pages are loaded)
        setTimeout(() => {
          console.log('🔍 Searching for target item in loaded content...');
          this.scrollToTargetItem(targetItemNumber, fallbackScrollPosition);

          // Clean up the saved state after successful restoration
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);

          // Mark restoration as complete and reset global flag
          this.isRestoring = false;
          this.restorationCompleted = true;
          window.infiniteScrollRestorationStarted = false; // Reset for potential future use
          console.log('✅ Restoration process completed and marked as done');
        }, 300); // Increased timeout to ensure DOM is fully updated
      } catch (error) {
        console.error('Error loading pages for scroll restoration:', error);
        this.loading.classList.add('dn');
        this.isRestoring = false;
        this.restorationCompleted = true;
        window.infiniteScrollRestorationStarted = false; // Reset on error too

        // Clean up on error
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
      }
    }

    // Scroll to the specific line item that was clicked
    scrollToTargetItem(targetItemNumber, fallbackScrollPosition) {
      // Debug: Log current state
      const currentItems = this.productsGrid.querySelectorAll('li[data-item-number]');
      console.log(`📊 Current grid has ${currentItems.length} items numbered from 1 to ${currentItems.length}`);

      if (targetItemNumber) {
        console.log(`🎯 Looking for target item #${targetItemNumber}...`);

        // Find the target item by data-item-number
        const targetItem = this.productsGrid.querySelector(`li[data-item-number="${targetItemNumber}"]`);

        if (targetItem) {
          // Scroll to the target item with some offset
          const offsetTop = targetItem.offsetTop - 100; // 100px offset from top

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });

          console.log(`✅ Successfully scrolled to item ${targetItemNumber} at position ${offsetTop}`);

          setTimeout(() => {
            targetItem.style.transform = '';
            targetItem.style.boxShadow = '';
            console.log('✨ Target item highlight removed');
          }, 1000);

          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          return;
        } else {
          console.log(`❌ Target item ${targetItemNumber} not found in ${currentItems.length} loaded items`);
          console.log(
            'Available item numbers:',
            Array.from(currentItems).map((item) => item.getAttribute('data-item-number'))
          );
        }
      }

      // Fallback to scroll position if item not found
      if (fallbackScrollPosition) {
        window.scrollTo({
          top: fallbackScrollPosition,
          behavior: 'smooth',
        });

        console.log(`📍 Used fallback scroll to position ${fallbackScrollPosition}`);
      } else {
        console.log('⚠️ No target item or fallback position available');
      }
    }

    loadNextPage() {
      this.loading.classList.remove('dn');
      this.currentPage++;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const products = html.querySelector('#product-grid');
          const infinite = html.querySelector('infinite-scroll');

          if (products && products.innerHTML.trim().length) {
            // Get the current number of items to continue numbering from
            const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
            const lastItemNumber =
              existingItems.length > 0
                ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                : 0;

            // Update line item numbers for new items before adding to DOM
            const newItems = products.querySelectorAll('li[data-item-number]');
            newItems.forEach((item, index) => {
              const newItemNumber = lastItemNumber + index + 1;
              item.setAttribute('data-item-number', newItemNumber);
            });

            // Add the updated items to the grid
            this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
          }

          if (infinite) {
            this.dataset.url = infinite.dataset.url;
            this.dataset.currentPage = this.currentPage;
          } else {
            this.dataset.lastPage = true;
            this.observer.unobserve(this);
            if (this.seo) this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
          }
          this.loading.classList.add('dn');
        })
        .catch((e) => {
          this.loading.classList.add('dn');
          console.error(e);
        });
    }
  }
  customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sliding-doors"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScrollReveal(section) {
    if (
      !section ||
      section.dataset.scrollRevealInitialized === "true"
    ) {
      return;
    }

    section.dataset.scrollRevealInitialized = "true";

    const leftDoor = section.querySelector(
      ".scroll-reveal__door--left"
    );

    const rightDoor = section.querySelector(
      ".scroll-reveal__door--right"
    );

    if (!leftDoor || !rightDoor) {
      return;
    }

    let ticking = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    /*
      The doors begin opening when 50% of the section
      has entered the viewport and finish exactly when
      its bottom edge reaches the viewport's bottom edge.
    */
    function easeInOutCubic(progress) {
      return progress < 0.5
        ? 2 * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 2) / 2;
    }

    function update() {
      ticking = false;

      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      /*
        Start when 50% of the section has entered the viewport.

        Finish exactly when the bottom edge of the section
        reaches the bottom edge of the viewport.

        This uses the section's actual rendered height, so
        progress spans the full distance between those two
        physical positions.
      */
      const sectionHeight = rect.height;

      // At the start, 50% of the section is visible:
      // rect.top = viewportHeight - (sectionHeight * 0.50)
      const startTop =
        viewportHeight - (sectionHeight * 0.50);

      // At the finish, the section bottom equals viewport bottom:
      // rect.top + sectionHeight = viewportHeight
      const finishTop =
        viewportHeight - sectionHeight;

      const animationDistance =
        Math.max(startTop - finishTop, 1);

      let progress =
        (startTop - rect.top) /
        animationDistance;

      progress = clamp(progress, 0, 1);

      const easedProgress = easeInOutCubic(progress);

      const styles = window.getComputedStyle(section);
      const isMobile = window.matchMedia(
        "(max-width: 700px)"
      ).matches;

      /*
        Read both values from CSS custom properties.
        The values are read from CSS custom properties.
      */
      const doorTravel = isMobile
        ? (
            parseFloat(
              styles.getPropertyValue(
                "--mobile-door-travel"
              )
            ) || 110
          )
        : (
            parseFloat(
              styles.getPropertyValue(
                "--door-travel"
              )
            ) || 105
          );

      const movement = doorTravel * easedProgress;

      leftDoor.style.transform =
        "translateX(" + -movement + "%)";

      rightDoor.style.transform =
        "translateX(" + movement + "%)";
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function handleResize() {
      requestUpdate();
    }

    window.addEventListener(
      "scroll",
      requestUpdate,
      { passive: true }
    );

    window.addEventListener(
      "resize",
      handleResize
    );

    update();

    section._scrollRevealCleanup = function () {
      window.removeEventListener(
        "scroll",
        requestUpdate
      );

      window.removeEventListener(
        "resize",
        handleResize
      );

      delete section._scrollRevealCleanup;
    };
  }

  function initAll() {
    document
      .querySelectorAll("[data-scroll-reveal]")
      .forEach(initScrollReveal);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initAll
    );
  } else {
    initAll();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      const section =
        event.target.querySelector(
          "[data-scroll-reveal]"
        );

      if (section) {
        initScrollReveal(section);
      }
    }
  );

  document.addEventListener(
    "shopify:section:unload",
    function (event) {
      const section =
        event.target.querySelector(
          "[data-scroll-reveal]"
        );

      if (
        section &&
        section._scrollRevealCleanup
      ) {
        section._scrollRevealCleanup();
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();
})();
